export default __webpack_public_path__ + "static/studio-slider-29-416010652c3fb9b046638a6fb120e863.png";